<template>
  <td :class="{system: typeof (system) !== 'undefined'}">
    <div v-if="typeof (system) === 'undefined'">
      <button v-if="data.pages !== null && data.pages.length > 0" :class="{badge: true, active: open}" @click="detail">{{data.pages.length}}</button>
      <input type="text" class="input" v-model="data.label">
      <div class="btns">
        <button v-if="data.pages === null || data.pages.length <= 0" class="btn btnRed sizeXs btnDel" @click="del(data)">삭제</button>
      </div>
      <ul v-show="open" class="infoList">
        <li v-for="(page, index) in data.pages" :key="index" class="mt5">
          {{page.title}}
          <a :href="pageLink(page.id)" class="pageId" target="_blank" title="페이지 바로가기">{{page.id}}</a>
        </li>
      </ul>
    </div>
    <div v-else class="input">
      <span class="badge">SYSTEM</span>
      {{`${data.name} (${data.desc})`}}
    </div>
  </td>
</template>

<script>
import UTIL from '@/common/util'

export default {
  name: 'CategoryItem',
  props: [
    'system',
    'data',
    'index'
  ],
  data () {
    return {
      open: false
    }
  },
  methods: {
    detail (id) {
      this.open = !this.open
    },
    pageLink (id) {
      const baseUrl = this.$store.state.page.VIEWER_BASE_URL
      const siteid = this.$store.state.authentication.userInfo.siteid
      const lang = this.$store.state.setting.lang.default
      const pageUrl = `${baseUrl}?site=${siteid}#/${lang}/page/${id}`
      return pageUrl
    },
    copyToClipboard (id) {
      UTIL.copyToClipboard(id)
      alert('id가 복사되었습니다')
    },
    update (id) {
      if (window.confirm('전송 카테고리명을 수정합니다')) {
        this.$emit('updateItem', id)
      }
    },
    del (data) {
      this.$emit('delItem', data)
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  position: relative;
  padding: 0 !important;
  &:not(.system) {
    padding-left: 1em !important;
    background-color: $color-white !important;
    .input {
      padding-left: 0.5em;
    }
  }
  &.system {
    background-color: $bg-default;
    cursor: not-allowed;
  }
  .input {
    width: auto;
    min-height: 0;
    padding: 1em;
    border-color: transparent;
    background-color: transparent;
    opacity: 0.5;
    &:focus {
      opacity: 1;
    }
  }
  .btns {
    position: absolute;
    top: 1em;
    right: 10px;
    .btn {
      margin-left: 5px;
    }
  }
}
.badge {
  display: inline-block;
  margin-right: 0.6em;
  padding: 2px 8px;
  font-size: 12px;
  color: $color-white;
  vertical-align: middle;
  border-radius: 20px;
  background-color: $color-grey;
  &.active {
    background-color: $color-primary;
    &+.input {
      opacity: 1;
    }
  }
}
.pageId {
  display: inline-block;
  margin-left: 0.5em;
  padding: 0 0.6em;
  font-size: 0.85em;
  color: $color-white;
  background-color: $color-lgrey;
  &:hover {
    background-color: $color-dark;
  }
}
.infoList {
  padding: 10px 15px 15px;
  border-top: 1px dashed $color-lgrey2;
}
</style>
